import store from '@/store/index'

export default {
    /**
     * Handle Authorization response
     * @param authResponse
     */
    buildAuthorization(authResponse) {
        if (authResponse.roles.indexOf('ROLE_ADMIN') === -1) {
            return null
        }

        let currentDate = new Date()
        const auth = {
            userId: authResponse.id,
            username: authResponse.username,
            roles: authResponse.roles,
            token: authResponse.token,
            userStatus: authResponse.userStatus,
            tokenExpires: new Date(currentDate.getTime() + (authResponse.expiresIn * 1000))
        }

        store.commit('setAuthorization', auth)
        return auth
    },

    /**
     * Get auth token if still valid
     * @return {null|*}
     */
    getAuthToken() {
        if (!store.state || !store.state.authorization) {
            return null
        }

        const auth = store.state.authorization;
        if (!auth || !auth.tokenExpires) {
            return null
        }

        let tokenExpires = new Date(auth.tokenExpires)
        if (auth && auth.token && tokenExpires > new Date()) {
            return auth.token
        }

        return null
    },

    /**
     * Get user roles
     */
    getRoles() {
        if (!store.state || !store.state.authorization) {
            return null
        }

        let authJson = JSON.parse(store.state.authorization);
        if (authJson !== undefined && authJson.roles !== undefined) {
            return authJson.roles
        }
    },

    getOpenUrls() {
        return [
            'error',
            'login',
            'logout',
            'reset_password'
        ];
    },

    /**
     * Check if logged in
     * @return {boolean}
     */
    isAuthenticated() {
        return this.getAuthToken() !== null
    },

    /**
     * Check if has role
     * @param role
     */
    hasRole(role) {
        return this.isAuthenticated() && this.getRoles().indexOf(role) !== -1
    }
}
